import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ProcessoSeletivoService } from './processo-seletivo.service';
const logoDefensoria = '/img/logo_branco.png';

export default function ProcessoNaoDisponivelPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [processoNome, setProcessoNome] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Tentar buscar o nome do processo seletivo usando endpoint público que retorna apenas nome
    if (id) {
      const processoSeletivoService = new ProcessoSeletivoService();
      processoSeletivoService.findOnePublicNome(parseInt(id))
        .then((processo) => {
          setProcessoNome(processo.nome);
          setIsLoading(false);
        })
        .catch(() => {
          // Se não conseguir buscar, apenas mostra mensagem genérica
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [id]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body text-center p-3">
              <div className="card-body text-center p-1 mb-2">
                <img style={{ width: '150px', height: '150px' }} src={logoDefensoria} alt="Logo Defensoria" className="img-fluid" />
              </div>
              <div className="mb-4">
                <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '4rem' }}></i>
              </div>
              <h2 className="card-title mb-4">Processo Seletivo Não Disponível</h2>
              {isLoading ? (
                <p className="text-muted">Carregando informações...</p>
              ) : (
                <>
                  {processoNome && (
                    <p className="lead mb-3">
                      <strong>{processoNome}</strong>
                    </p>
                  )}
                  <p className="text-muted mb-4">
                    Este processo seletivo não está disponível para inscrições no momento.
                  </p>
                  <p className="text-muted mb-4">
                    O processo pode estar:
                  </p>
                  <ul className="list-unstyled text-start mb-4">
                    <li className="mb-2">
                      <i className="bi bi-dash-circle me-2"></i>
                      <strong>Fechado:</strong> As inscrições foram encerradas
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-dash-circle me-2"></i>
                      <strong>Fora do período:</strong> As inscrições ainda não começaram ou já terminaram
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-dash-circle me-2"></i>
                      <strong>Em rascunho:</strong> O processo ainda está sendo configurado
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-dash-circle me-2"></i>
                      <strong>Finalizado:</strong> O processo já foi concluído
                    </li>
                  </ul>
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate('/candidato/login')}
                    >
                      Ir para o Portal do Candidato
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

